import {HttpErrorResponse} from '@angular/common/http';
import {POLARIS_FAILURE_MESSAGE} from './model/polaris-state.constants';

export const POLARIS_NO_ACCESS_MESSAGE = 'You don\'t have access to the requested brand data';

/** The text shown in the chat when sending a Polaris message fails. */
export function getSendFailureMessage(error: unknown): string {
  if (!(error instanceof HttpErrorResponse)) {
    return POLARIS_FAILURE_MESSAGE;
  }
  const serverMessage = error.error?.message;
  if (error.status === 403) {
    // Nest guards (e.g. OwnershipGuard) return the default 'Forbidden resource' body - not user-facing
    return serverMessage && serverMessage !== 'Forbidden resource' ? serverMessage : POLARIS_NO_ACCESS_MESSAGE;
  }
  // 422 = Polaris could not finish the answer; the server sends a message written for the user
  if (error.status === 422 && typeof serverMessage === 'string' && serverMessage.trim()) {
    return serverMessage;
  }
  return POLARIS_FAILURE_MESSAGE;
}
